// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Paper,
//   Modal,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   FormControl,
//   Select,
//   MenuItem,
//   FormHelperText,
//   TextField,
//   TablePagination,
// } from '@mui/material';
// import {
//   Breadcrumb,
//   CTSinput,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from '../../reusableComponent/Reusables';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useForm, Controller } from 'react-hook-form';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import { Print } from '@mui/icons-material';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import customermaster from '../../../services/masters/customerMaster.Service';
// import emptycollectionreport from '../../../services/emptycylindercollection.service';
// import { useSelector } from 'react-redux';

// const printStyles = `
//   .print-header {
//     display: none; /* Hidden on screen */
//   }
//   @media print {
//     body * {
//       visibility: hidden;
//     }
//     .printable-area, .printable-area * {
//       visibility: visible;
//     }
//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//     }
//     .no-print {
//       display: none !important;
//     }
//     .printable-table {
//       width: 100%;
//       border-collapse: collapse;
//     }
//     .printable-table th, .printable-table td {
//       padding: 8px;
//       font-size: 10px;
      
//     }
//     .printable-image {
//       max-width: 80px;
//       max-height: 80px;
//       object-fit: cover;
//       vertical-align: middle;
//     }
//     .print-header {
//       display: block; /* Visible when printing */
//       text-align: left;
//       margin-bottom: 20px;
//     }
//     .print-header h1 {
//       font-size: 20px;
//       margin: 0 0 10px 0;
//     }
//     .print-header .inline-details {
//       display: flex;
//       flex-wrap: wrap;
//       justify-content: left;
//       gap: 20px;
//       font-size: 14px;
//     }
//     .printable-table-container {
//       max-height: none !important;
//       overflow: visible !important;
//     }
//   }
// `;

// const EmptyCollectionReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

//   const [successMessage, setSuccessMessage] = useState('');
//   const [displayData, setDisplayData] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [depots, setDepots] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState('');
//   const [openDetail, setOpenDetail] = useState(false);
//   const [dialogData, setDialogData] = useState([]);
//   const [dialogTitle, setDialogTitle] = useState('');
//   const [filterType, setFilterType] = useState('customer'); // Default to 'customer'
//   const [subBoxValue, setSubBoxValue] = useState('');
//   const [formValues, setFormValues] = useState({
//     entry_date_from: '2025-09-01', // Default From Date
//     entry_date_to: '2025-09-30',   // Default To Date
//     filterType: 'customer',        // Default Filter By
//     subBox: '',
//   });
//   const defaultRowsPerPage = useSelector(state => state.grn.rows_per_page || 15);

//   // Pagination state
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   // Define filter options for "Filter By"
//   const filterOptions = [
//     { value: 'customer', label: 'Customer' },
//     { value: 'depot', label: 'Depot' },
//     { value: 'product', label: 'Product' },
//     { value: 'status', label: 'Status' },
//   ];



//   // Calculate total count and pagination info
//   const totalCount = displayData.length;
//   const startRecord = totalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//   const endRecord = totalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, totalCount);
//   const paginationInfo = `${startRecord}-${endRecord} of ${totalCount}`;
  

//   // Dynamically populate sub-filter options based on filterType
//   const getSubBoxOptions = () => {
//     switch (filterType) {
//       case 'customer':
//         return [
//           { value: 'all', label: 'All' },
//           ...customers.map((cust) => ({ value: cust.cust_id, label: cust.cust_name })),
//         ];
//       case 'depot':
//         return [
//           { value: 'all', label: 'All' },
//           ...depots.map((depot) => ({ value: depot.depot_id, label: depot.depot_name })),
//         ];
//       case 'product':
//         return [
//           { value: 'all', label: 'All' },
//           ...products.map((prod) => ({ value: prod.prod_code, label: `${prod.prod_name} (${prod.prod_code})` })),
//         ];
//       case 'status':
//         return [
//           { value: 'all', label: 'All' },
//           { value: 'Empty', label: 'Empty' },
//           { value: 'Full', label: 'Full' },
//         ];
//       default:
//         return [];
//     }
//   };

//   const subBoxOptions = getSubBoxOptions();

//   // Get dynamic label for Sub Filter based on filterType
//   const getSubFilterLabel = () => {
//     const selectedFilter = filterOptions.find((option) => option.value === formValues.filterType);
//     return selectedFilter ? selectedFilter.label : 'Sub Filter';
//   };

//   // Get display value for Sub Filter
//   const getSubFilterDisplayValue = () => {
//     if (!formValues.subBox || formValues.subBox === 'all') return 'All';
//     switch (formValues.filterType) {
//       case 'customer':
//         return customers.find(c => c.cust_id === formValues.subBox)?.cust_name || formValues.subBox;
//       case 'depot':
//         return depots.find(d => d.depot_id === formValues.subBox)?.depot_name || formValues.subBox;
//       case 'product':
//         return products.find(p => p.prod_code === formValues.subBox)?.prod_name || formValues.subBox;
//       case 'status':
//         return formValues.subBox;
//       default:
//         return formValues.subBox;
//     }
//   };

//   const { control, handleSubmit, setValue, formState: { errors } } = useForm({
//     defaultValues: {
//       entry_date_from: '2025-09-01', // Default From Date
//       entry_date_to: '2025-09-30',   // Default To Date
//       filterType: 'customer',        // Default Filter By
//       subBox: '',
//     },
//     resolver: async (data) => {
//       const errors = {};
//       if (!data.entry_date_from) errors.entry_date_from = { message: 'From Date is required' };
//       if (!data.entry_date_to) errors.entry_date_to = { message: 'To Date is required' };
//       if (data.entry_date_from && data.entry_date_to && dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from))) {
//         errors.entry_date_to = { message: 'To Date cannot be before From Date' };
//       }
//       if (!data.filterType) errors.filterType = { message: 'Filter Type is required' };
//       if (!data.subBox) errors.subBox = { message: 'Sub Filter is required' };
//       return { values: data, errors };
//     },
//   });

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         setLoading(true);
//         const customerData = await customermaster.getCustomerList({ page: 0, size: 999, searchKey: '' });
//         setCustomers(customerData || []);
//       } catch (error) {
//         console.error('Data fetching failed', error);
//         setSuccessMessage('Error fetching data');
//         setCustomers([]);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchData();

//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   const handleShow = async (formData) => {
//     try {
//       setLoading(true);
//       setDisplayData([]);
//       setDepots([]);
//       setProducts([]);
//       setController({ page: 0, rowsPerPage: defaultRowsPerPage }); // Reset pagination

//       // Store form values for printing
//       setFormValues({
//         entry_date_from: formData.entry_date_from,
//         entry_date_to: formData.entry_date_to,
//         filterType: formData.filterType,
//         subBox: formData.subBox,
//       });

//       const filterParams = {
//         page: 0,
//         size: 999,
//         searchKey: '',
//         from_date: formData.entry_date_from,
//         to_date: formData.entry_date_to,
//         customer_id: formData.filterType === 'customer' && formData.subBox !== 'all' ? formData.subBox : '',
//       };

//       const response = await emptycollectionreport.getEmptyCylinderList(filterParams);
//       const fetchedData = response?.data || response || [];

//       // Extract unique depots and products
//       const uniqueDepots = [...new Set(fetchedData.map(item => item.receiving_depot))].filter(Boolean).map((depot, index) => ({
//         depot_id: `depot_${index}`,
//         depot_name: depot,
//       }));
//       const uniqueProducts = [...new Set(fetchedData.map(item => item.prod_code))].filter(Boolean).map((code, index) => ({
//         prod_code: code,
//         prod_name: fetchedData.find(item => item.prod_code === code)?.prod_name || code,
//       }));

//       setDepots(uniqueDepots);
//       setProducts(uniqueProducts);

//       const flattenedData = fetchedData.map((item, index) => {
//         let images = [];
//         try {
//           images = typeof item.upload_receipt === 'string' ? JSON.parse(item.upload_receipt) : item.upload_receipt || [];
//         } catch (error) {
//           console.error('Error parsing upload_receipt:', error);
//           images = [];
//         }

//         return {
//           sr_no: index + 1,
//           date: dayjs(item.date).format('YYYY-MM-DD'),
//           cust_name: item.name_of_customer || 'N/A',
//           cylinder_code: item.cylinder_code || 'N/A',
//           prod_code: item.prod_code || 'N/A',
//           prod_name: item.prod_name || 'N/A',
//           ecr_no: item.ecr_no || 'N/A',
//           vehicle_no: item.vehicle_no || 'N/A',
//           receiving_depot: item.receiving_depot || 'N/A',
//           no_of_cylinders: item.no_of_cylinders || 0,
//           images: images,
//           cylinders: item.cylinders || [],
//         };
//       });

//       // Apply client-side filtering
//       let filteredData = flattenedData;
//       if (formData.filterType && formData.subBox && formData.subBox !== 'all') {
//         switch (formData.filterType) {
//           case 'customer':
//             filteredData = filteredData.filter(row => row.cust_name === customers.find(c => c.cust_id === formData.subBox)?.cust_name);
//             break;
//           case 'depot':
//             filteredData = filteredData.filter(row => row.receiving_depot === depots.find(d => d.depot_id === formData.subBox)?.depot_name);
//             break;
//           case 'product':
//             filteredData = filteredData.filter(row => row.prod_code === formData.subBox);
//             break;
//           case 'status':
//             filteredData = filteredData.filter(row => row.cylinders.some(cyl => cyl.status === formData.subBox));
//             break;
//           default:
//             break;
//         }
//       }

//       setDisplayData(filteredData);

//     } catch (error) {
//       console.error('Error fetching data for display:', error);
//       setDisplayData([]);
//       setDepots([]);
//       setProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageClick = (image) => {
//     setSelectedImage(image);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedImage('');
//   };

//   const handleCylinderClick = (row) => {
//     setDialogData(row.cylinders || []);
//     setDialogTitle(`Cylinder Details for ECR No: ${row.ecr_no}`);
//     setOpenDetail(true);
//   };

//   const handleClose = () => {
//     setOpenDetail(false);
//     setDialogData([]);
//     setDialogTitle('');
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleChangePage = (event, newPage) => {
//     setController(prev => ({ ...prev, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       page: 0, // Reset to first page
//       rowsPerPage: parseInt(event.target.value, 10),
//     });
//   };

//   const dateConversion = (date) => {
//     if (!date) return '';
//     const today = new Date(date);
//     const dd = String(today.getDate()).padStart(2, '0');
//     const mm = String(today.getMonth() + 1).padStart(2, '0');
//     const yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   // Use all data for printing, not paginated
//   const printData = displayData;
//     const paginatedData = printData.slice(
//   controller.page * controller.rowsPerPage,
//   controller.page * controller.rowsPerPage + controller.rowsPerPage
// );

//   return (
//     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: 'Empty Collection Report' }]} />
//         <Typography className={styles.header_txt}>EMPTY COLLECTION REPORT</Typography>

//         <form onSubmit={handleSubmit(handleShow)} className="no-print">
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller
//                   name="entry_date_from"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       {...field}
//                       size="small"
//                       fullWidth
//                       type="date"
//                       InputLabelProps={{ shrink: true }}
//                       error={!!errors.entry_date_from}
//                       helperText={errors.entry_date_from?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller
//                   name="entry_date_to"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       {...field}
//                       size="small"
//                       fullWidth
//                       type="date"
//                       InputLabelProps={{ shrink: true }}
//                       error={!!errors.entry_date_to}
//                       helperText={errors.entry_date_to?.message}
//                     InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>Filter By</Typography>
//                 <Controller
//                   name="filterType"
//                   control={control}
//                   render={({ field }) => (
//                     <FormControl fullWidth size="small" error={!!errors.filterType} sx={{ ml: 1 }}>
//                       <CTSinput
//                         select
//                         {...field}
//                         onChange={(e) => {
//                           field.onChange(e);
//                           setFilterType(e.target.value);
//                           setSubBoxValue('');
//                           setValue('subBox', '');
//                         }}
//                          InputProps={{
                                                      
//                                                       className: styles.CTSinput_Box,
//                                                     }}
//                       >
//                         <MenuItem value="">
//                           <em>Select Filter</em>
//                         </MenuItem>
//                         {filterOptions.map((option) => (
//                           <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </CTSinput>
//                       <FormHelperText>{errors.filterType?.message}</FormHelperText>
//                     </FormControl>
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>{getSubFilterLabel()}</Typography>
//                 <Controller
//                   name="subBox"
//                   control={control}
//                   render={({ field }) => (
//                     <FormControl fullWidth size="small" error={!!errors.subBox} disabled={!filterType} sx={{ ml: 1 }}>
//                       <CTSinput
//                       select
//                         {...field}
//                         onChange={(e) => {
//                           field.onChange(e);
//                           setSubBoxValue(e.target.value);
//                         }}
//                          InputProps={{
                                                      
//                                                       className: styles.CTSinput_Box,
//                                                     }}
//                       >
//                         <MenuItem value="">
//                           <em>Select Option</em>
//                         </MenuItem>
//                         {subBoxOptions.map((option) => (
//                           <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                           </MenuItem>
//                         ))}
//                       </CTSinput>
//                       <FormHelperText>{errors.subBox?.message}</FormHelperText>
//                     </FormControl>
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
//                 <Button
//                   variant="contained"
//                   startIcon={<VisibilityIcon />}
//                   type="submit"
//                   className={`${styles.addnew_btn}`}
//                   disabled={loading || !filterType || !subBoxValue}
//                 >
//                   <Typography className={`${styles.addnew_btn_txt}`}>Show</Typography>
//                 </Button>
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <Box className="printable-area">
//           {/* Print Header Section */}
//           <Box className="print-header">
//             <Typography variant="h1" sx={{fontWeight:"bold"}}>EMPTY COLLECTION REPORT</Typography>
//             <Box className="inline-details">
//               <Typography variant="body1">
//                 From Date: {dateConversion(formValues.entry_date_from)}
//               </Typography>
//               <Typography variant="body1">
//                 To Date: {dateConversion(formValues.entry_date_to)}
//               </Typography>
//               <Typography variant="body1">
//                 Filter By: {filterOptions.find(opt => opt.value === formValues.filterType)?.label || 'N/A'}
//               </Typography>
//               <Typography variant="body1">
//                 {getSubFilterLabel()}: {getSubFilterDisplayValue()}
//               </Typography>
//             </Box>
//           </Box>

//           <Grid item xs={12} sx={{ mt: 4 }}>
//             <Paper sx={{ width: '100%' }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "flex-end",
//                   alignItems: "center",
//                   padding: "10px",
//                 }}
//                 className="no-print"
//               >
//                 <Button
//                   style={{ float: "right", cursor: "pointer" }}
//                   variant="outlined"
//                   startIcon={<Print />}
//                   onClick={handlePrint}
//                   disabled={displayData.length === 0}
//                 >
//                   Print
//                 </Button>
//               </Box>
//               <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table-container`}>
//                 <Table size="small" stickyHeader className="printable-table">
//                   <TableHead className={styles.table_head_container}>
//                     <StyledTableRow>
//                       <StyledTableCell align="left">Sr No</StyledTableCell>
//                       <StyledTableCell align="left">Date</StyledTableCell>
//                       <StyledTableCell align="left" sx={{width:'20%'}}>Customer Name</StyledTableCell>
//                       <StyledTableCell align="left">Product Code</StyledTableCell>
//                       <StyledTableCell align="left">Product Description</StyledTableCell>
//                       <StyledTableCell align="left">ECR No</StyledTableCell>
//                       <StyledTableCell align="left">No Of Cylinder</StyledTableCell>
//                       <StyledTableCell align="left">Vehicle No</StyledTableCell>
//                       <StyledTableCell align="left">Depot</StyledTableCell>
//                       <StyledTableCell align="left">Images</StyledTableCell>
//                     </StyledTableRow>
//                   </TableHead>
//              <TableBody sx={{ backgroundColor: '#fff' }}>
//   {loading ? (
//     <StyledTableRow>
//       <StyledTableCell colSpan={10} align="center">
//         <Typography>Loading data...</Typography>
//       </StyledTableCell>
//     </StyledTableRow>
//   ) : printData.length === 0 ? (
//     <StyledTableRow>
//       <StyledTableCell colSpan={10} align="center">
//         <Typography>No data found</Typography>
//       </StyledTableCell>
//     </StyledTableRow>
//   ) : (
//     // Apply pagination here
//     printData
//       .slice(
//         controller.page * controller.rowsPerPage,
//         controller.page * controller.rowsPerPage + controller.rowsPerPage
//       )
//       .map((row, index) => (
//         <StyledTableRow key={index}>
//           <StyledTableCell align="center" className={styles.inspection_cell}>
//             {controller.page * controller.rowsPerPage + index + 1}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {dateConversion(row.date)}
//           </StyledTableCell>
//           <StyledTableCell align="left" sx={{ width: "20px" }}> <Typography sx={{
//                                  width: '100%',
//                                  maxWidth: '100%',
//                                  whiteSpace: 'normal',
//                                  wordBreak: 'break-word',
//                                }}
//                                className={styles.inspection_cell}> {row.cust_name || "-"}</Typography></StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.prod_code}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.prod_name}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.ecr_no}
//           </StyledTableCell>
//           <StyledTableCell
//             align="center"
//             className={styles.inspection_cell}
//             sx={{
//               cursor: row.no_of_cylinders > 0 ? 'pointer' : 'default',
//               color: row.no_of_cylinders > 0 ? '#1976d2' : 'inherit',
//             }}
//             onClick={() => row.no_of_cylinders > 0 && handleCylinderClick(row)}
//           >
//             {row.no_of_cylinders}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.vehicle_no}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.receiving_depot}
//           </StyledTableCell>
//           <StyledTableCell>
//             {row.images.length > 0 ? (
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 {row.images.map((image, imgIndex) => (
//                   <img
//                     key={imgIndex}
//                     src={image}
//                     alt={`Receipt ${imgIndex + 1}`}
//                     className="printable-image"
//                     style={{
//                       width: '50px',
//                       height: '50px',
//                       objectFit: 'cover',
//                       cursor: 'pointer',
//                     }}
//                     onClick={() => handleImageClick(image)}
//                     onError={(e) => {
//                       e.target.src = '/path/to/fallback/image.jpg';
//                     }}
//                   />
//                 ))}
//               </Box>
//             ) : (
//               'No images'
//             )}
//           </StyledTableCell>
//         </StyledTableRow>
//       ))
//   )}
// </TableBody>

//                 </Table>
//               </TableContainer>
//               <TablePagination
//                 rowsPerPageOptions={[10, 25, 100]}
//                 component="div"
//                 count={totalCount}
//                 rowsPerPage={controller.rowsPerPage}
//                 page={controller.page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 labelDisplayedRows={() => paginationInfo}
//                 className="no-print"
//               />
//             </Paper>
//           </Grid>
//         </Box>

//         <Dialog
//           PaperProps={{
//             sx: {
//               minWidth: "90%",
//               maxHeight: "90%",
//             },
//           }}
//           onClose={handleClose}
//           open={openDetail}
//           className="no-print"
//         >
//           <DialogTitle id="customized-dialog-title">
//             {dialogTitle}
//             <IconButton
//               aria-label="close"
//               onClick={handleClose}
//               sx={{
//                 position: "absolute",
//                 right: 8,
//                 top: 8,
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table-container`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Owner</StyledTableCell>
//                     <StyledTableCell align="left">Status</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {dialogData.length > 0 ? (
//                     dialogData.map((row, index) => (
//                       <StyledTableRow key={index}>
//                         <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.cylinder_no || "-"}
//                         </StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.tag_no || "-"}
//                         </StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.owner || "-"}
//                         </StyledTableCell>
//                         <StyledTableCell className={styles.inspection_cell}>
//                           {row.status || "-"}
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ))
//                   ) : (
//                     <StyledTableRow>
//                       <StyledTableCell colSpan={5} align="center">
//                         No cylinder details available
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage('')}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />

//         <Modal
//           open={openModal}
//           onClose={handleCloseModal}
//           aria-labelledby="image-modal-title"
//           aria-describedby="image-modal-description"
//           sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//           className="no-print"
//         >
//           <Box
//             sx={{
//               position: 'relative',
//               maxWidth: '90%',
//               maxHeight: '90%',
//               bgcolor: 'background.paper',
//               boxShadow: 24,
//               p: 2,
//               borderRadius: 2,
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <IconButton
//               sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
//               onClick={handleCloseModal}
//             >
//               <CloseIcon />
//             </IconButton>
//             <img
//               src={selectedImage}
//               alt="Full-size receipt"
//               style={{
//                 maxWidth: '100%',
//                 maxHeight: '80vh',
//                 objectFit: 'contain',
//               }}
//               onError={(e) => {
//                 e.target.src = '/path/to/fallback/image.jpg';
//               }}
//             />
//           </Box>
//         </Modal>
//       </Box>
//     </Box>
//   );
// };

// export default EmptyCollectionReport;



import React, { useEffect, useState } from 'react';
import {
  Box, Button, Typography, Grid, TableContainer, Table, TableHead, TableBody,
  Paper, Modal, IconButton, Dialog, DialogContent, MenuItem, FormHelperText,
} from '@mui/material';
import {
  Breadcrumb, CTSinput, CTSRinput, StyledTableCell, StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import customermaster from '../../../services/masters/customerMaster.Service';
import emptycollectionreport from '../../../services/emptycylindercollection.service';
import CustomPagination from '../../reusableComponent/CustomPagination';
import { useSelector } from 'react-redux';

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
    .print-header-info { display: block !important; margin-bottom: 10px; }
  }
  .print-header-info { display: none; }
`;

const EmptyCollectionReport = () => {
  const location = useLocation();

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const defaultRowsPerPage = useSelector(state => state.grn.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [depots, setDepots] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterType, setFilterType] = useState('customer');
  const [subBoxValue, setSubBoxValue] = useState('');
const today = dayjs();
const defaultFrom = today.startOf('month').format('YYYY-MM-DD');
const defaultTo = today.endOf('month').format('YYYY-MM-DD');

const [formValues, setFormValues] = useState({
  entry_date_from: defaultFrom,
  entry_date_to: defaultTo,
  filterType: 'customer',
  subBox: '',
});
  

  const [controller, setController] = useState({ page: 0, rowsPerPage: defaultRowsPerPage });

  const filterOptions = [
    { value: 'customer', label: 'Customer' },
    { value: 'depot',    label: 'Depot'    },
    { value: 'product',  label: 'Product'  },
    { value: 'status',   label: 'Status'   },
  ];

  const totalCount = displayData.length;

  const getSubBoxOptions = () => {
    switch (filterType) {
      case 'customer': return [{ value: 'all', label: 'All' }, ...customers.map(c => ({ value: c.cust_id, label: c.cust_name }))];
      case 'depot':    return [{ value: 'all', label: 'All' }, ...depots.map(d => ({ value: d.depot_id, label: d.depot_name }))];
      case 'product':  return [{ value: 'all', label: 'All' }, ...products.map(p => ({ value: p.prod_code, label: `${p.prod_name} (${p.prod_code})` }))];
      case 'status':   return [{ value: 'all', label: 'All' }, { value: 'Empty', label: 'Empty' }, { value: 'Full', label: 'Full' }];
      default:         return [];
    }
  };
  const subBoxOptions = getSubBoxOptions();

  const getSubFilterLabel = () => filterOptions.find(o => o.value === formValues.filterType)?.label || 'Sub Filter';

  const getSubFilterDisplayValue = () => {
    if (!formValues.subBox || formValues.subBox === 'all') return 'All';
    switch (formValues.filterType) {
      case 'customer': return customers.find(c => c.cust_id === formValues.subBox)?.cust_name || formValues.subBox;
      case 'depot':    return depots.find(d => d.depot_id === formValues.subBox)?.depot_name || formValues.subBox;
      case 'product':  return products.find(p => p.prod_code === formValues.subBox)?.prod_name || formValues.subBox;
      case 'status':   return formValues.subBox;
      default:         return formValues.subBox;
    }
  };

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
   defaultValues: {
  entry_date_from: defaultFrom,
  entry_date_to: defaultTo,
  filterType: 'customer',
  subBox: '',
},
    resolver: async (data) => {
      const errors = {};
      if (!data.entry_date_from) errors.entry_date_from = { message: 'From Date is required' };
      if (!data.entry_date_to)   errors.entry_date_to   = { message: 'To Date is required' };
      if (data.entry_date_from && data.entry_date_to && dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from)))
        errors.entry_date_to = { message: 'To Date cannot be before From Date' };
      if (!data.filterType) errors.filterType = { message: 'Filter Type is required' };
      if (!data.subBox)     errors.subBox     = { message: 'Sub Filter is required' };
      return { values: data, errors };
    },
  });

  // ── Effect: customers + print styles ─────────────────────────────────────
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const customerData = await customermaster.getCustomerList({ page: 0, size: 999, searchKey: '' });
        setCustomers(customerData || []);
      } catch (error) {
        setSuccessMessage('Error fetching data');
        setCustomers([]);
      } finally { setLoading(false); }
    }
    fetchData();

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const handleShow = async (formData) => {
    try {
      setLoading(true);
      setDisplayData([]);
      setDepots([]);
      setProducts([]);
      setController({ page: 0, rowsPerPage: defaultRowsPerPage });

      setFormValues({
        entry_date_from: formData.entry_date_from,
        entry_date_to:   formData.entry_date_to,
        filterType:      formData.filterType,
        subBox:          formData.subBox,
      });

      const response = await emptycollectionreport.getEmptyCylinderList({
        page: 0, size: 999, searchKey: '',
        from_date: formData.entry_date_from,
        to_date:   formData.entry_date_to,
        customer_id: formData.filterType === 'customer' && formData.subBox !== 'all' ? formData.subBox : '',
      });
      const fetchedData = response?.data || response || [];
console.log('First item keys:', fetchedData[0]); // ← yeh add karo
      const uniqueDepots   = [...new Set(fetchedData.map(i => i.receiving_depot))].filter(Boolean)
        .map((d, idx) => ({ depot_id: `depot_${idx}`, depot_name: d }));
      const uniqueProducts = [...new Set(fetchedData.map(i => i.prod_code))].filter(Boolean)
        .map(code => ({ prod_code: code, prod_name: fetchedData.find(i => i.prod_code === code)?.prod_name || code }));

      setDepots(uniqueDepots);
      setProducts(uniqueProducts);

      const flattenedData = fetchedData.map((item, index) => {
        let images = [];
        try { images = typeof item.upload_receipt === 'string' ? JSON.parse(item.upload_receipt) : item.upload_receipt || []; }
        catch { images = []; }
        return {
          sr_no:            index + 1,
          date:             dayjs(item.date).format('YYYY-MM-DD'),
          cust_name:        item.name_of_customer || 'N/A',
          cylinder_code:    item.cylinder_code    || 'N/A',
          prod_code:        item.prod_code        || 'N/A',
          prod_name:        item.prod_name        || 'N/A',
          ecr_no:           item.ecr_no           || 'N/A',
          vehicle_no:       item.vehicle_no       || 'N/A',
          receiving_depot:  item.receiving_depot  || 'N/A',
          no_of_cylinders:  item.no_of_cylinders  || 0,
          images,
          cylinders: item.cylinders || [],
        };
      });

      let filteredData = flattenedData;
      if (formData.filterType && formData.subBox && formData.subBox !== 'all') {
        switch (formData.filterType) {
          case 'customer': filteredData = filteredData.filter(r => r.cust_name === customers.find(c => c.cust_id === formData.subBox)?.cust_name); break;
          case 'depot':    filteredData = filteredData.filter(r => r.receiving_depot === depots.find(d => d.depot_id === formData.subBox)?.depot_name); break;
          case 'product':  filteredData = filteredData.filter(r => r.prod_code === formData.subBox); break;
          case 'status':   filteredData = filteredData.filter(r => r.cylinders.some(c => c.status === formData.subBox)); break;
        }
      }
      setDisplayData(filteredData);
    } catch (error) {
      console.error(error);
      setDisplayData([]);
    } finally { setLoading(false); }
  };

  const handleImageClick   = (img) => { setSelectedImage(img); setOpenModal(true); };
  const handleCloseModal   = ()    => { setOpenModal(false); setSelectedImage(''); };
  const handlePrint        = ()    => { window.print(); };

  const handleCylinderClick = (row) => {
    setSelectedRow(row);
    setDialogData(row.cylinders || []);
    setOpenDetail(true);
  };
  const handleClose = () => { setOpenDetail(false); setDialogData([]); setSelectedRow(null); };

  const handleChangePage       = (e, newPage) => setController(prev => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (e)         => setController({ rowsPerPage: parseInt(e.target.value, 10), page: 0 });

  const dateConversion = (date) => {
    if (!date) return '';
    const d  = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
  };

  const cylinderHeaders = ['Sr No', 'Cylinder No', 'Tag No', 'Owner', 'Status'];

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Empty Collection Report' }]} />
        <Typography className={styles.header_txt}>EMPTY COLLECTION SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          onSubmit={handleSubmit(handleShow)}
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
        >
          {/* From Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              From Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_from" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_from} helperText={errors.entry_date_from?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* To Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              To Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_to" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_to} helperText={errors.entry_date_to?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* Filter By */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Filter By <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="filterType" control={control} render={({ field }) => (
              <CTSinput select size="small" fullWidth {...field}
                onChange={(e) => { field.onChange(e); setFilterType(e.target.value); setSubBoxValue(''); setValue('subBox', ''); }}
                error={!!errors.filterType}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value=""><em>Select Filter</em></MenuItem>
                {filterOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSinput>
            )} />
            {errors.filterType && <FormHelperText error>{errors.filterType.message}</FormHelperText>}
          </Box>

          {/* Sub Filter */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              {getSubFilterLabel()} <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="subBox" control={control} render={({ field }) => (
              <CTSinput select size="small" fullWidth {...field}
                disabled={!filterType}
                onChange={(e) => { field.onChange(e); setSubBoxValue(e.target.value); }}
                error={!!errors.subBox}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value=""><em>Select Option</em></MenuItem>
                {subBoxOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSinput>
            )} />
            {errors.subBox && <FormHelperText error>{errors.subBox.message}</FormHelperText>}
          </Box>

          {/* Show + Print buttons */}
          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '8px', flex: '0 0 auto' }}>
            <Button
              variant="contained" startIcon={<VisibilityIcon />} type="submit"
              className={styles.addnew_btn}
              disabled={loading || !filterType || !subBoxValue}
              size="small" sx={{ height: '30px', whiteSpace: 'nowrap' }}
            >
              <Typography className={styles.addnew_btn_txt}>Show</Typography>
            </Button>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: 'nowrap', height: '30px' }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: '100%' }}>
            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Empty Collection Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  From: {dateConversion(formValues.entry_date_from)} &nbsp;|&nbsp;
                  To: {dateConversion(formValues.entry_date_to)} &nbsp;|&nbsp;
                  {getSubFilterLabel()}: {getSubFilterDisplayValue()}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {['Sr No',  'ECR No','Date', 'Customer Name', 'Product Code', 'Product Description',
                        'No Of Cylinder', 'Vehicle No', 'Depot', 'Images'].map(h => (
                        <StyledTableCell key={h} sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>{h}</StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow><StyledTableCell colSpan={10} align="center"><Typography>Loading data...</Typography></StyledTableCell></StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow><StyledTableCell colSpan={10} align="center"><Typography>No data found</Typography></StyledTableCell></StyledTableRow>
                    ) : (
                      displayData
                        .slice(controller.page * controller.rowsPerPage, (controller.page + 1) * controller.rowsPerPage)
                        .map((row, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell align="left" className={styles.inspection_cell}>
                              {controller.page * controller.rowsPerPage + index + 1}
                            </StyledTableCell>
                             <StyledTableCell onClick={() => handleCylinderClick(row)}>
                              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', color: '#1976d2 !important', textDecoration: 'underline' }}>
                                {row.ecr_no}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.date)}</StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell} sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '160px' }}>
                              {row.cust_name || '-'}
                            </StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell}>{row.prod_code}</StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell}>{row.prod_name}</StyledTableCell>

                            {/* ECR No — clickable */}
                            {/* <StyledTableCell onClick={() => handleCylinderClick(row)}>
                              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', color: '#1976d2 !important', textDecoration: 'underline' }}>
                                {row.ecr_no}
                              </Typography>
                            </StyledTableCell> */}

                            <StyledTableCell className={styles.inspection_cell} align="left">
                              {row.no_of_cylinders}
                            </StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell}>{row.vehicle_no}</StyledTableCell>
                            <StyledTableCell className={styles.inspection_cell}>{row.receiving_depot}</StyledTableCell>
                            <StyledTableCell>
                              {row.images.length > 0 ? (
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                  {row.images.map((img, i) => (
                                    <img key={i} src={img} alt={`Receipt ${i + 1}`}
                                      style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer', borderRadius: '4px' }}
                                      onClick={() => handleImageClick(img)}
                                      onError={(e) => { e.target.src = '/path/to/fallback/image.jpg'; }}
                                    />
                                  ))}
                                </Box>
                              ) : (
                                <Typography sx={{ fontSize: '11px', color: '#A0AEC0' }}>No images</Typography>
                              )}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={totalCount}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage} onClose={() => setSuccessMessage('')}
          message={successMessage} autoHideDuration={2000}
          vertical="top" horizontal="right" className="no-print"
        />

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail} onClose={handleClose} maxWidth={false} className="no-print"
          sx={{
            '& .MuiDialog-paper': {
              margin: 'auto', width: '92vw', maxHeight: '85vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
              EMPTY COLLECTION DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

            {/* ── ECR Info Card ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 ECR Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: 'ECR No',           value: selectedRow?.ecr_no,                          border: true,  bottom: true  },
                  { label: 'Date',             value: dateConversion(selectedRow?.date),             border: true,  bottom: true  },
                  { label: 'Customer Name',    value: selectedRow?.cust_name,                       border: true,  bottom: true  },
                  { label: 'Product Code',     value: selectedRow?.prod_code,                       border: false, bottom: true  },
                  { label: 'Product Name',     value: selectedRow?.prod_name,                       border: true,  bottom: false },
                  { label: 'Vehicle No',       value: selectedRow?.vehicle_no,                      border: true,  bottom: false },
                  { label: 'Depot',            value: selectedRow?.receiving_depot,                 border: true,  bottom: false },
                  { label: 'No of Cylinders',  value: selectedRow?.no_of_cylinders,                 border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid key={label} item xs={12} sm={6} md={3}
                    sx={{ borderRight: border ? '1px solid #EDF2F7' : 'none', borderBottom: bottom ? '1px solid #EDF2F7' : 'none', padding: '12px 16px' }}
                  >
                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: label === 'ECR No' ? 700 : 600, color: label === 'ECR No' ? '#1C3A5E' : '#2D3748', fontFamily: "'Inter', Arial, sans-serif" }}>
                      {value || 'N/A'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              {/* <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  🛢️ Cylinder Details
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: '350px' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map(header => (
                        <StyledTableCell key={header} align="center"
                          sx={{ backgroundColor: '#1C3A5E !important', color: '#fff !important', fontFamily: "'Inter', Arial, sans-serif", fontWeight: 700, fontSize: '11px', padding: '10px 8px', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255,255,255,0.1)' }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {dialogData.length > 0 ? (
                      dialogData.map((row, index) => (
                        <StyledTableRow key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
                        >
                          {[index + 1, row.cylinder_no || 'N/A', row.tag_no || 'N/A', row.owner || 'N/A', row.status || 'N/A'].map((val, ci) => (
                            <StyledTableCell key={ci} align="center"
                              sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleClose}
              sx={{ background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600, textTransform: 'none', padding: '7px 20px', borderRadius: '8px', fontFamily: "'Inter', Arial, sans-serif", '&:hover': { background: '#971f16' } }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        {/* ── Image Modal ── */}
        <Modal open={openModal} onClose={handleCloseModal}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="no-print"
        >
          <Box sx={{ position: 'relative', maxWidth: '90%', maxHeight: '90%', bgcolor: 'background.paper', boxShadow: 24, p: 2, borderRadius: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }} onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
            <img src={selectedImage} alt="Full-size receipt"
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
              onError={(e) => { e.target.src = '/path/to/fallback/image.jpg'; }}
            />
          </Box>
        </Modal>

      </Box>
    </Box>
  );
};

export default EmptyCollectionReport;